<template>
  <div v-if="airQuality" class="frame">
    <div class="div2_pie">
      <air-quality-chart :air-quality="airQuality" :type="'pm25'" :value='airQuality["pm25"]'/>
    </div>
    <div class="div2_pie">
      <air-quality-chart :air-quality="airQuality" :type="'outdoor_pm25'" :value='airQuality["outdoor_pm25"]'/>
    </div>
    <div class="div2_end">
      <div v-for="(item, index) in airList" :key="index" class="container">
        <div class="title">
          <span>{{ item.ch }}</span>
          <span>{{ item.en }}</span>
        </div>
        <div class="count">
          <img :src="item.iconUrl" alt="" />
          <span>{{ airQuality[item.id] || "-" }}</span>
          <span>{{ item.unit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";
import { get } from "lodash";
import * as api from "../services/api";
import airQualityChart from "./airQualityChart.vue";

export const AIR_LIST = [
  {
    id: "temp",
    ch: "室内温度",
    en: "Temperature",
    iconUrl: require("../../static/img/temp.png"),
    unit: "℃",
    val: "",
  },
  {
    id: "hum",
    ch: "室内湿度",
    en: "Humidity",
    iconUrl: require("../../static/img/hum.png"),
    unit: "%",
    val: "",
  },
  {
    id: "voc",
    ch: "TVOC",
    en: "TVOC",
    iconUrl: require("../../static/img/sensor_id.png"),
    unit: "mg/m3",
    val: "",
  },
  {
    id: "co2",
    ch: "二氧化碳",
    en: "CO2",
    iconUrl: require("../../static/img/co2.png"),
    unit: "ppm",
    val: "",
  },
];
export default {
  name: "AirQuality",
  components: {
    airQualityChart,
  },

  data() {
    return {
      config,
      airQuality: null,
      airList: AIR_LIST,
    };
  },
  mounted: function () {
    this.loadData();
    const that = this;
    setInterval(() => {
      that.loadData();
    }, 10 * 60 * 1000); // load data every 10 minutes
  },
  methods: {
    // ...mapActions(['getLocation', 'getFloorInfos', 'getAreas', 'getVisitors', 'getReservations', 'getCentrifugeToken']),
    get,
    loadData: async function () {
      // fetch air quality
      this.airQuality = (
        await api.getAirRealTime({
          location_id: config.locationId,
        })
      ).data;
      // console.log("*** meeting rooms", this.meetingRooms);
      console.log("*** air quality", this.airQuality);
      this.loading = false;
    },
  },
};
</script>

<style lang="less">
.frame {
  display: flex;
  flex: 1;
}
.div2_pie {
  width: calc((4 / 14) * 100%);
  // padding: 0 0 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.div2_end {
  width: calc((6 / 14) * 100%);
  // padding: 0 20px;
  display: flex;
  // justify-content: center;
  // justify-content: flex-end;
  // align-items: center;
  flex-wrap: wrap;
  flex: 1;
  margin-left: 100px;
  .container:nth-of-type(3) {
    margin-top: 30px;
  }
  .container:nth-of-type(4) {
    margin-top: 30px;
  }
  .container {
    width: 50%;
    display: flex;
    flex-direction: column;
    // align-items: center;
    // justify-content: center;
    // align-items: left;
    .title {
      margin-bottom: 10px;
      span:nth-of-type(1) {
        font-size: 16px;
        font-weight: bold;
        color: #2da8ff;
        line-height: 24px;
        margin-right: 10px;
      }
      span:nth-of-type(2) {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        line-height: 21px;
      }
    }
    .count {
      display: flex;
      align-items: center;
      img {
        width: 34px;
        height: 34px;
        margin-right: 12px;
      }
      span:nth-of-type(1) {
        font-size: 34px;
        //font-family: DINPro-Bold, DINPro;
        font-weight: bold;
        color: #ffffff;
        line-height: 34px;
        margin-right: 5px;
      }
      span:nth-of-type(2) {
        font-size: 16px;
        font-family: Helvetica;
        color: #ffffff;
        line-height: 16px;
        align-self: flex-end;
        margin-bottom: 2px;
      }
    }
  }
}
</style>
